import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext';

import { transformOptionsByPath } from '@openx/components-deal/lib/utils/transformOptionsByPath';
import type { HierarchyItem } from '@openx/types/hierarchyItem';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useBrandsOptionsFetch: DealProviderConfig['useBrandsOptionsFetch'] = () => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.brand_salesforce_id',
    },
    fetchPolicy: 'network-only',
  });

  const { list, mapById } = useMemo(() => transformOptionsByPath<HierarchyItem>(optionsByPath), [optionsByPath]);

  return {
    list,
    loading,
    mapById,
    refetch,
  };
};
